<template>
  <div>
    <ValidationProvider
      name="Change in Land Use"
      rules="required"
      v-slot="{ errors }"
      slim
    >
      <b-form-group
        label-cols="12"
        label-cols-sm="7"
        content-cols-sm="5"
        label-for="landUseChange">
        <template v-slot:label>
          <span class="req-ind">*</span>Will you be converting any of your land to something other than forest within the next 2 years?
        </template>
        <b-form-radio-group
          id="landUseChange"
          name="landUseChange"
          v-model="harvestDetails.landUseChange"
          @change="onLandUseChange"
          :aria-describedby="$errorsIdString(errors, 'landUseChange')"
          :disabled="mfsAdmin"
        >
          <b-form-radio class="noselect" :value="true">Yes</b-form-radio>
          <b-form-radio class="noselect" :value="false">No</b-form-radio>
        </b-form-radio-group>
        <InputErrors
          :errors="errors"
          errorsIdPrefix="landUseChange"
          class="d-block invalid-feedback text-right"
        />
      </b-form-group>
    </ValidationProvider>
    <template v-if="harvestDetails.landUseChange">
      <ValidationProvider
        name="Land Use Category"
        rules="required"
        v-slot="{ errors, classes }"
      >
        <b-form-group
          label-cols="12"
          label-cols-sm="6"
          :content-cols-sm="isExtraSmall ? 6 : 5"
          label-for="landUseCategory"
          :label-class="isExtraSmall ? '' : 'offset-1'">
          <template v-slot:label>
            <span class="req-ind">*</span>Pick the expected post-operation land use.
          </template>
          <select
            id="landUseCategory"
            name="landUseCategory"
            v-model="harvestDetails.landUseChangeCategoryId"
            class="form-control"
            :class="classes"
            :aria-describedby="$errorsIdString(errors, 'landUseCategory')"
            :disabled="mfsAdmin"
          >
            <option :value="null" disabled>Select a Land Use Category</option>
            <option
              v-for="option in landUseCategories"
              :key="option.id"
              :value="option.id"
            >
              {{option.name}}
            </option>
          </select>
          <InputErrors :errors="errors" errorsIdPrefix="landUseCategory" />
        </b-form-group>
      </ValidationProvider>
      <ValidationProvider
        name="Land Use Change Area"
        rules="required|max_decimal_singular:1|min_value:0.1|lessThanOrEqual:Total Harvest Area"
        v-slot="{ errors, classes }"
        slim
      >
        <b-form-group
          label-cols="12"
          label-cols-sm="6"
          :content-cols-sm="isExtraSmall ? 6 : 5"
          label-for="landUseChangeArea"
          :label-class="isExtraSmall ? '' : 'offset-1'">
          <template v-slot:label>
            <span class="req-ind">*</span>Enter area of expected land use change (acres).
          </template>
          <b-form-input
            type="number"
            id="landUseChangeArea"
            name="landUseChangeArea"
            v-model="harvestDetails.landUseChangeArea"
            placeholder="Enter Land Use Change Area"
            :class="classes"
            maxlength="7"
            :aria-describedby="$errorsIdString(errors, 'landUseChangeArea')"
            :disabled="mfsAdmin"
          />
          <InputErrors :errors="errors" errorsIdPrefix="landUseChangeArea" />
        </b-form-group>
      </ValidationProvider>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LookupModules from '@/store/moduleConfig';

export default {
  name: 'LandUseChangeForm',
  props: {
    harvestDetails: {
      type: Object,
      default() {
        return {
          landUseChange: null,
          landUseChangeCategoryId: null,
          landUseChangeArea: null,
        };
      },
    },
  },
  computed: {
    ...mapState(LookupModules.LAND_USE_CATEGORIES.namespace, {
      landUseCategories: state => state.options,
      landUseCategoriesLoading: state => state.loading,
    }),
    ...mapState(['isExtraSmall']),
    ...mapGetters('User', ['mfsAdmin']),
  },
  created() {
    this.$store.dispatch(`${LookupModules.LAND_USE_CATEGORIES.namespace}/fetchOptions`);
  },
  methods: {
    onLandUseChange(value) {
      if (!value) {
        this.harvestDetails.landUseChangeCategoryId = null;
        this.harvestDetails.landUseChangeArea = null;
      }
    },
  },
};
</script>
